import script from "./SearchContComp.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchContComp.vue?vue&type=script&setup=true&lang=js"

import "./SearchContComp.vue?vue&type=style&index=0&id=a791b0cc&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a791b0cc"]])

export default __exports__